import { createHttpClient } from "@intergamma/account"

import { z } from "zod"

export type DutchAddressRequest = { zipCode: string; houseNumber: string }
export type BelgiumCityRequest = { zipOrCity: string }
export type BelgiumStreetRequest = {
  zipCode: string
  street: string
  language: "nl" | "fr"
}
export type BelgiumStreetResponse = string[]

export type DutchAddressResponse = {
  city: string
  houseNumber: string
  street: string
  validated: true
  zipCode: string
}

export type BelgianAddressSearchResponse = {
  city: string
  postalCode: string
  street: string
  houseNumber: string
  houseNumberAddition: string
  showText: string
  zipCode: string
  poBox: boolean
  streetNumber: string
}[]

export function createZipCodeService(MYACCOUNT_URL: string, CHECKOUT_URL: string) {
  const baseClient = createHttpClient(`${MYACCOUNT_URL}/api/zipcode`, {
    withCredentials: true,
  })

  const checkoutClient = createHttpClient(`${CHECKOUT_URL}/api/checkout`, {
    withCredentials: true,
  })

  return {
    getDutchAddress({ zipCode, houseNumber }: DutchAddressRequest): Promise<DutchAddressResponse | null> {
      return baseClient.get<DutchAddressResponse>(`/nl?zipCode=${zipCode}&houseNumber=${houseNumber}`)
    },
    searchBelgianAddress(query: string): Promise<BelgianAddressSearchResponse> {
      return checkoutClient.get<BelgianAddressSearchResponse>("/address/autocomplete/be", {
        params: new URLSearchParams({
          query: z.string().min(1).parse(query),
        }),
      })
    },
  }
}
